import React from "react";

export const ReplySVG = () => (
	<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
		<path
			d="M537.016,909.264c-7.034,0-14.006-2.372-19.671-6.97L18.508,496.986C11.232,491.055,7,482.161,7,472.781
			c0-9.374,4.232-18.267,11.508-24.204L517.345,43.272c9.318-7.551,22.258-9.104,33.064-3.959
			c10.871,5.175,17.785,16.135,17.785,28.162v219.277c243.388,16.107,436.483,219.246,436.483,466.625v62.353
			c0,12.18-7.097,23.235-18.147,28.314c-11.054,5.119-24.054,3.292-33.311-4.626l-52.55-45.027
			c-93.318-79.986-210.359-126.841-332.476-133.66v217.36c0,12.022-6.914,22.986-17.785,28.158
			C546.146,908.262,541.58,909.268,537.016,909.264L537.016,909.264z M125.715,472.781L506.65,782.309V614.776
			c0-15.697,12.702-28.401,28.399-28.401c134.946,0,265.707,48.367,368.18,136.193l0.972,0.834
			c-2.664-201.286-167.231-364.213-369.148-364.213c-15.699,0-28.4-12.704-28.4-28.399V163.258
			C506.65,163.258,125.715,472.781,125.715,472.781L125.715,472.781z"
		/>
	</svg>
);

export const GoogleSVG = () => (
	<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
		<g>
			<path
				fill="#59C36A"
				d="M827.301,875.968c-84.521,71.388-194.169,116.693-313.528,116.693c-177.609,0-333.52-97.848-418.041-240.62
				l31.646-145.858l140.255-26.039c32.553,105.078,130.779,182.178,246.141,182.178c55.964,0,107.937-17.703,150.767-49.112
				l134.777,20.558L827.301,875.968z"
			/>
			<path
				fill="#00A66C"
				d="M827.301,875.968l-27.984-142.201l-134.777-20.558c-42.83,31.409-94.803,49.112-150.767,49.112v230.34
				C633.132,992.661,742.779,947.355,827.301,875.968z"
			/>
			<g id="Connected_Home_1_">
				<g>
					<g>
						<g>
							<path
								fill="#FFDA2D"
								d="M256.781,505.331c0,26.267,3.998,51.396,10.851,74.813l-171.9,171.897
								c-42.83-71.957-69.29-156.48-69.29-246.71c0-90.233,26.46-174.754,69.29-246.711l137.965,23.743l33.936,148.154
								C260.779,453.932,256.781,479.06,256.781,505.331L256.781,505.331z"
							/>
						</g>
					</g>
				</g>
			</g>
			<path
				fill="#4086F4"
				d="M1001.103,505.331c0,148.48-68.719,281.547-173.802,370.637L664.539,713.209
				c33.121-23.988,61.107-55.971,79.384-93.66h-230.15c-15.993,0-28.556-12.567-28.556-28.554V419.666
				c0-15.99,12.563-28.554,28.556-28.554h450.78c13.707,0,25.698,9.708,27.983,23.412
				C998.247,444.225,1001.103,475.063,1001.103,505.331L1001.103,505.331z"
			/>
			<path
				fill="#4175DF"
				d="M743.924,619.549c-18.275,37.689-46.264,69.672-79.382,93.66l162.759,162.759
				c105.083-89.09,173.802-222.153,173.802-370.637c0-30.269-2.855-61.106-8.567-90.807c-2.284-13.704-14.278-23.412-27.984-23.412
				H513.772v228.437H743.924z"
			/>
			<path
				fill="#FF641A"
				d="M835.297,154.107c0.571,7.996-2.855,15.422-7.996,21.131L705.086,296.881
				c-9.704,10.278-25.694,11.421-37.118,2.855c-45.119-33.693-98.231-51.396-154.195-51.396
				c-115.361,0-213.588,77.095-246.141,182.178L95.731,258.62C180.253,115.848,336.163,18,513.772,18
				c113.647,0,224.439,41.88,311.244,114.978C831.298,138.119,834.723,146.112,835.297,154.107L835.297,154.107z"
			/>
			<path
				fill="#F03800"
				d="M667.966,299.736c11.422,8.567,27.411,7.423,37.119-2.855l122.214-121.643
				c5.143-5.709,8.569-13.133,7.996-21.131c-0.575-7.997-3.999-15.988-10.279-21.13C738.212,59.88,627.42,18,513.772,18v230.34
				C569.736,248.34,622.849,266.043,667.966,299.736z"
			/>
		</g>
	</svg>
);

export const FacebookSVG = () => (
	<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
		<g>
			<path
				fill="#4A7AFF"
				d="M1015.363,506.525c0,279.749-226.775,506.524-506.525,506.524c-279.749,0-506.524-226.775-506.524-506.524
	C2.313,226.775,229.089,0,508.838,0C788.588,0,1015.363,226.775,1015.363,506.525z"
			/>
			<path
				fill="#FFFFFF"
				d="M663.688,149.015v114.697c0,0-131.686-19.113-131.686,65.843v84.957h118.941L636.08,544.072H532.002v337.709
	H400.316V544.072l-112.572-2.126V414.512H398.19V316.81c0,0-7.288-145.343,135.938-172.038
	C593.602,133.68,663.688,149.015,663.688,149.015z"
			/>
			<path
				fill="#DCE1EB"
				d="M663.688,263.712V149.015c0,0-70.086-15.335-129.56-4.243c-9.291,1.73-17.932,3.973-25.993,6.623v730.387
	h23.867V544.072h104.07l14.871-129.561H532.002c0,0,0,0,0-84.957C532.002,244.599,663.688,263.712,663.688,263.712z"
			/>
		</g>
	</svg>
);

export const TwitterSVG = () => (
	<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
		<path
			fill="#03A9F4"
			d="M1006.701,163.276c-6.71-7.344-17.513-9.249-26.334-4.649c-9.059,4.107-18.431,7.508-28.042,10.136
      c14.983-19.171,26.285-40.938,33.356-64.208c3.113-11.713-3.859-23.729-15.573-26.834c-6.251-1.668-12.92-0.484-18.218,3.219
      c-33.365,18.063-68.824,31.936-105.59,41.3c-75.666-71.428-190.939-80.332-276.685-21.372
      c-66.047,44.667-102.419,121.845-94.796,201.207c-143.168-12.197-274.902-83.141-363.884-195.983
      c-4.574-5.527-11.491-8.575-18.653-8.206c-7.262,0.436-13.833,4.443-17.545,10.703c-30.202,49.365-38.951,108.916-24.231,164.878
      c7.548,28.757,20.485,55.813,38.136,79.74c-7.942-3.894-15.434-8.682-22.292-14.268c-9.413-7.632-23.229-6.193-30.86,3.22
      c-3.17,3.909-4.904,8.788-4.912,13.815c1.314,81.186,45.891,155.489,116.917,194.842c-9.586-1.175-19.04-3.204-28.264-6.054
      c-11.607-3.491-23.846,3.088-27.338,14.687c-1.519,5.06-1.166,10.505,1.004,15.326c30.826,69.055,92.447,119.488,166.24,136.039
      c-70.303,39.665-151.25,56.33-231.5,47.657c-10.399-1.323-20.255,5.002-23.385,15.015c-3.228,9.931,0.993,20.765,10.095,25.891
      c98.254,58.384,210.029,90.139,324.3,92.16c109.632-0.403,216.707-33.152,307.808-94.132
      C820.37,681.983,928.769,474.763,913.672,289.359c37.184-27.533,69.439-61.153,95.403-99.446
      C1014.406,181.519,1013.437,170.586,1006.701,163.276z"
		/>
	</svg>
);

export const ImageSvg = () => (
	<svg viewBox="0 0 1024 1024" width="1em" height="1em" fill="currentColor">
		<g>
			<g>
				<path
					fill="#E5E1E5"
					d="M163.033,1011.756L2.746,191.353c-4.863-24.879,11.365-48.991,36.245-53.852l124.042-24.234l194.642-42.82
          l279.663,941.308H163.033V1011.756z"
				/>
			</g>
			<path
				fill="#99E6FC"
				d="M163.033,680.979L68.355,196.393l94.678-18.501l143.802-23.615l62.994,584.599L163.033,680.979z"
			/>
			<g id="XMLID_159_">
				<g>
					<path
						fill="#F9F7F8"
						d="M1014.357,64.9v957.461c0,25.351-20.549,45.899-45.899,45.899H208.93
            c-25.351,0-45.901-20.549-45.901-45.899V64.9c0-25.35,20.551-45.9,45.901-45.9h759.528C993.809,19,1014.357,39.551,1014.357,64.9
            z"
					/>
				</g>
				<path
					fill="#EFEDEF"
					d="M574.473,971.206c-90.848,0-164.495-73.646-164.495-164.493V19H208.93
          c-25.351,0-45.901,20.551-45.901,45.9v957.461c0,25.351,20.551,45.899,45.901,45.899h759.528
          c25.351,0,45.899-20.549,45.899-45.899v-51.155H574.473z"
				/>
				<path
					fill="#FEC165"
					d="M950.933,737.554V234.861c0-7.122-5.774-12.896-12.897-12.896H239.354c-7.12,0-12.896,5.774-12.896,12.896
          v502.692H950.933z"
				/>
				<path
					fill="#FDB441"
					d="M409.978,221.965H239.354c-7.12,0-12.896,5.774-12.896,12.896v502.692h183.52V221.965z"
				/>
				<circle fill="#FEE903" cx="588.693" cy="600.309" r="246.948" />
				<path
					fill="#F4D902"
					d="M409.978,770.729V429.889c-42.274,44.316-68.229,104.339-68.229,170.419
          C341.748,666.391,367.703,726.41,409.978,770.729z"
				/>
				<g>
					<path
						fill="#99E6FC"
						d="M902.813,668.316c-57.591-25.393-122.604-28.267-182.203-8.034l-51.163,17.336
            c-52.369,17.759-109.135,17.759-161.505,0l-51.163-17.336c-59.602-20.232-124.611-17.358-182.182,8.034l-48.142,21.226v105.269
            l80.12,33.354h599.658l44.699-33.354V689.542L902.813,668.316z"
					/>
					<path
						fill="#62DBFB"
						d="M409.978,828.165V649.264c-45.72-6.239-92.605,0.184-135.379,19.053l-48.141,21.226v105.269
            l80.119,33.354H409.978z"
					/>
					<path
						fill="#62DBFB"
						d="M950.933,794.811v61.709c0,5.452-4.424,9.878-9.879,9.878H236.332c-5.453,0-9.877-4.426-9.877-9.878
            v-61.709l48.142-21.229c57.57-25.39,122.58-28.268,182.182-8.055l51.163,17.358c52.37,17.759,109.136,17.759,161.505,0
            l51.163-17.358c59.6-20.213,124.612-17.335,182.203,8.055L950.933,794.811z"
					/>
					<path
						fill="#01D0FB"
						d="M236.332,866.397h184.86c-7.214-18.51-11.215-38.625-11.215-59.685v-52.188
            c-45.72-6.231-92.605,0.192-135.379,19.061l-48.141,21.226v61.71c-0.003,5.451,4.421,9.875,9.874,9.875V866.397z"
					/>
				</g>
			</g>
		</g>
	</svg>
);

export const ProdutorSVG = () => (
	<span role="img" className="anticon">
		<svg
			version="1.1"
			id="Layer_1"
			xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 122.88 95.45"
			style={{
				width: "1.2em",
				height: "1.2em",
				verticalAlign: "middle",
				overflow: "hidden",
				fill: "#455560",
			}}
		>
			<g>
				<path
					className="st0"
					d="M75.35,52.51v-8.35c0.38-1.61,1.09-2.09,1.88-2.24C79.39,41.58,79.16,52.01,75.35,52.51L75.35,52.51z 
           M46.03,38.26c1.65,0.62,2,2,1.08,2.52c-1.08,0.61-2.45-0.3-3.51-0.64c-2.76-0.88-6.04-0.98-8.43,0.51 
           c-0.63,0.4-1.28,0.91-1.94,1.54c0.25-0.87,0.62-1.67,1.18-2.37C36.8,36.79,42.82,36.62,46.03,38.26L46.03,38.26z 
           M56.44,38.26 c-1.65,0.62-2,2-1.08,2.52c1.08,0.61,2.45-0.3,3.51-0.64c2.76-0.88,6.04-0.98,8.43,0.51c0.63,0.4,1.28,0.91,1.94,1.54 
           c-0.25-0.87-0.62-1.67-1.18-2.37C65.67,36.79,59.65,36.62,56.44,38.26L56.44,38.26z M10.78,25.99h14.18 
           c0.03-3.09,0.31-6.09,0.71-8.98c1.12-8.02,9.55-24.28,20.06-13.27c4.65,4.36,7.96,3.68,12.64,0.23c4.15-3.06,8.89-7.3,14.61,0.34 
           c3.22,4.29,3.8,10.99,4.47,15.68l0.43,3.02c0.23,0.94,0.44,1.93,0.6,2.98h14.04c2.29,0,4.16,1.75,4.16,3.89l0,0 
           c0,2.14-1.87,3.89-4.16,3.89H79.06c0,1.66-0.06,3.4-0.19,5.25L77.29,40c1.27-0.09,2.17,0.7,2.7,2.04c0.27,0.67,0.44,1.5,0.5,2.39 
           c0.06,0.84,0.05,1.77-0.06,2.71c-0.38,3.42-1.95,6.99-4.86,7.42c-0.13,0.02-0.25,0.02-0.38,0.01v0.44c0,0.02,0,0.04,0,0.06 
           c0.26,6.35-1.87,8.82-5.26,12.05c0.12,0.05,0.23,0.12,0.33,0.21c3.94,3.97,5.06,4.37,8.49,5.58c1.04,0.37,2.29,0.81,3.81,1.41l0,0 
           c0.03,0.01,0.06,0.03,0.1,0.04c2.59,1.38,5.01,2.95,7.23,4.76c0.24-1.1,0.45-2.21,0.64-3.34l4.69,1.95 
           c-1.07,1.09-2.06,2.22-2.93,3.5c1.16,1.11,2.24,2.29,3.26,3.55c3.51,4.36,6.16,10.19,7.71,16.76c0.03,0.08,0.04,0.17,0.04,0.27 
           c0,0.52-0.42,0.93-0.93,0.93l-101.44,0v0c-0.06,0-0.13-0.01-0.19-0.02c-0.5-0.11-0.83-0.6-0.72-1.1 
           c1.29-6.13,3.49-11.92,6.73-16.29c3.25-4.39,7.52-7.82,12.92-10.2v0c1-0.46,2.08-0.94,3.06-1.38l0,0 
           c4.18-1.86,6.15-2.73,10.24-6.94c0.02-0.02,0.04-0.04,0.06-0.05l-0.04-0.03c-2.72-2.54-4.01-3.74-5.1-8.94 
           c-0.02-0.11-0.03-0.21-0.03-0.31h0v-2.93c-0.15,0.03-0.32,0.03-0.48,0c-2.91-0.43-4.49-4-4.86-7.42c-0.1-0.94-0.12-1.87-0.06-2.71 
           c0.07-0.9,0.24-1.72,0.5-2.39c0.58-1.46,1.58-2.27,3.03-2c0.7,0.13,1.33,0.49,1.86,1.09v-1.19l-1.19-0.67 
           c-0.27-1.79-0.15-3.65,0.3-5.52H10.78c-2.29,0-4.16-1.75-4.16-3.89l0,0C6.62,27.74,8.49,25.99,10.78,25.99L10.78,25.99z 
           M72.88,33.76H30.03v23.73c1.17,5.63,1.92,5.4,5.53,8.93l6.25,6.12c1.13,0.93,2.4,1.48,3.76,1.8c2.38,0.56,10.36,0.73,12.6,0.02 
           c1.36-0.44,2.64-1.24,3.82-2.49l4.54-4.41c4.39-4.26,6.67-5.39,6.35-12.44L72.88,33.76L72.88,33.76z 
           M115.34,42.31 c2.84-3.61,5.13-7.51,7.54-11.58c-1.63,3.93-3.29,7.8-5.55,11.57L115.34,42.31L115.34,42.31L115.34,42.31z 
           M108.43,38.52 c1.27-4.41,2.87-8.79,4.77-13.12c-2.34,3.49-4.23,7.4-5.92,11.51L108.43,38.52L108.43,38.52z 
           M119.69,24.6 c-3.02,7.03-2.28,8.01-3.91,13.79c-0.28,1-0.57,1.94-1.18,2.64c-0.35,0.4-0.8,0.72-1.41,0.93c-2.54,0.88-3.73-0.69-3.95-3 
           c0.04-0.75,0.37-1.55,0.91-2.34c0.71-1.05,1.81-2.11,3.14-3.08C116.7,31.08,117.57,28.29,119.69,24.6L119.69,24.6L119.69,24.6z 
           M102.09,72.45c1.13,0.01,2.27,0,3.36-0.25c0.87-0.2,1.71-0.56,2.5-1.17c-0.48,0.68-0.97,1.34-1.47,2 
           c-2.08,2.72-4.74,5.83-8.56,5.12c-1.12-0.21-2.09-0.81-2.46-1.98c-0.32-1.01,0.08-2.15,1.32-2.91 
           C98.41,72.25,100.27,72.42,102.09,72.45L102.09,72.45L102.09,72.45z M105.7,64.96c1.13-0.02,2.27-0.07,3.35-0.35 
           c0.86-0.23,1.69-0.61,2.46-1.25c-0.46,0.69-0.93,1.37-1.41,2.04c-2,2.78-4.56,5.97-8.41,5.37c-1.13-0.17-2.12-0.75-2.52-1.91 
           c-0.35-1,0.01-2.15,1.23-2.95C102.02,64.87,103.88,64.99,105.7,64.96L105.7,64.96L105.7,64.96z M108.95,58.08 
           c1.13-0.08,2.26-0.18,3.33-0.52c0.85-0.27,1.66-0.69,2.4-1.37c-0.42,0.71-0.86,1.42-1.31,2.11c-1.86,2.87-4.26,6.19-8.13,5.79 
           c-1.14-0.12-2.15-0.64-2.61-1.78c-0.4-0.98-0.1-2.15,1.08-3.01C105.27,58.17,107.14,58.2,108.95,58.08L108.95,58.08L108.95,58.08z 
           M112.69,50.88c1.13-0.03,2.27-0.09,3.35-0.39c0.86-0.24,1.68-0.63,2.45-1.27c-0.45,0.69-0.91,1.38-1.39,2.06 
           c-1.97,2.8-4.5,6.01-8.35,5.46c-1.13-0.16-2.12-0.73-2.54-1.88c-0.36-1-0.01-2.15,1.2-2.96C109.01,50.83,110.87,50.93,112.69,50.88 
           L112.69,50.88L112.69,50.88z M116.12,43.82c1.13-0.13,2.25-0.29,3.3-0.69c0.83-0.31,1.62-0.77,2.33-1.49 
           c-0.39,0.73-0.78,1.46-1.2,2.18c-1.71,2.96-3.94,6.39-7.83,6.19c-1.14-0.06-2.18-0.53-2.7-1.65c-0.45-0.96-0.2-2.14,0.93-3.06 
           C112.45,44.1,114.31,44.04,116.12,43.82L116.12,43.82L116.12,43.82z M91.73,66.77c-0.64-0.94-1.25-1.89-1.64-2.94 
           c-0.31-0.83-0.48-1.73-0.4-2.73c-0.3,0.77-0.59,1.55-0.86,2.33c-1.12,3.24-2.25,7.17,0.46,9.97c0.79,0.82,1.83,1.3,3.01,0.96 
           c1.02-0.29,1.75-1.25,1.7-2.71C93.93,69.72,92.76,68.27,91.73,66.77L91.73,66.77L91.73,66.77z M95.5,59.66 
           c-0.64-0.94-1.25-1.89-1.64-2.94c-0.31-0.83-0.48-1.73-0.4-2.73c-0.3,0.77-0.59,1.55-0.86,2.33c-1.12,3.24-2.25,7.17,0.46,9.97 
           c0.79,0.82,1.83,1.3,3.01,0.96c1.02-0.29,1.75-1.25,1.7-2.71C97.69,62.61,96.52,61.16,95.5,59.66L95.5,59.66L95.5,59.66z 
           M99.26,52.55c-0.64-0.94-1.25-1.89-1.64-2.94c-0.31-0.83-0.48-1.73-0.4-2.73c-0.3,0.77-0.59,1.55-0.86,2.33 
           c-1.12,3.24-2.25,7.17,0.46,9.97c0.79,0.82,1.83,1.3,3.01,0.96c1.02-0.29,1.75-1.25,1.7-2.71C101.45,55.5,100.28,54.05,99.26,52.55 
           L99.26,52.55L99.26,52.55z M102.89,45.38c-0.64-0.94-1.25-1.89-1.64-2.94c-0.31-0.83-0.48-1.73-0.4-2.73 
           c-0.3,0.77-0.59,1.55-0.86,2.33c-1.12,3.23-2.25,7.17,0.46,9.97c0.79,0.82,1.83,1.3,3.01,0.96c1.02-0.29,1.75-1.25,1.7-2.71 
           C105.09,48.34,103.92,46.89,102.89,45.38L102.89,45.38L102.89,45.38z M106.75,38.27c-0.59-0.97-1.16-1.95-1.49-3.02 
           c-0.27-0.85-0.39-1.75-0.26-2.75c-0.34,0.76-0.66,1.52-0.97,2.29c-1.28,3.18-2.6,7.05-0.04,9.98c0.75,0.86,1.76,1.39,2.96,1.11 
           c1.03-0.24,1.81-1.16,1.83-2.62C108.79,41.33,107.7,39.82,106.75,38.27L106.75,38.27L106.75,38.27z M35.23,68.9l-0.02,0.02 
           c-4.12,4.23-6.09,5.1-10.29,6.96c-0.65,0.29-1.36,0.6-2.12,0.95c2.09,5.02,6.93,8.85,13.19,11.38c4.21,1.7,8.98,2.73,13.81,2.95 
           c4.82,0.21,9.7-0.38,14.14-1.93c6.5-2.26,11.88-6.4,14.92-13.19c-0.95-0.38-1.76-0.69-2.46-0.95c-3.43-1.3-4.46-1.69-8.32-5.55 
           c-0.02-0.02-0.04-0.04-0.05-0.06c-0.1-0.1-0.16-0.22-0.2-0.35c-0.11,0.1-0.21,0.21-0.32,0.31l-4.34,4.21 
           c-0.68,0.71-1.38,1.29-2.11,1.77c-0.75,0.48-1.53,0.85-2.34,1.11c-2.61,0.84-10.72,0.65-13.42,0.02c-0.78-0.18-1.54-0.43-2.27-0.77 
           c-0.73-0.34-1.44-0.78-2.12-1.34c-0.01-0.01-0.1-0.09-0.1-0.09L35.23,68.9L35.23,68.9z M37.42,44.18 
           c-0.36,0.14-0.74-0.08-0.86-0.48c-0.12-0.4,0.07-0.84,0.42-0.98c2.73-1.07,5.5-0.99,8.24,0c0.36,0.13,0.55,0.56,0.44,0.97 
           c-0.11,0.41-0.49,0.63-0.85,0.5c-0.45-0.16-0.91-0.3-1.36-0.41c0.05,0.16,0.07,0.33,0.07,0.51c0,1.05-0.85,1.91-1.91,1.91 
           c-1.05,0-1.91-0.85-1.91-1.91c0-0.26,0.05-0.51,0.15-0.73C39.05,43.66,38.24,43.86,37.42,44.18L37.42,44.18L37.42,44.18z 
           M59.54,43.61c-0.08,0.21-0.12,0.44-0.12,0.68c0,1.05,0.85,1.91,1.91,1.91c1.05,0,1.91-0.85,1.91-1.91c0-0.3-0.07-0.59-0.2-0.84 
           c0.83,0.09,1.67,0.27,2.52,0.55c0.36,0.12,0.74-0.12,0.84-0.53c0.1-0.41-0.11-0.84-0.47-0.96c-1.38-0.45-2.75-0.67-4.12-0.67 
           c-1.37,0-2.72,0.23-4.07,0.67c-0.36,0.12-0.57,0.55-0.46,0.95c0.1,0.41,0.48,0.64,0.84,0.53C58.59,43.83,59.07,43.71,59.54,43.61 
           L59.54,43.61L59.54,43.61z M59.94,60.89c-0.93,0.32-1.89,0.58-2.87,0.8v0c-1.01,0.28-1.95,0.45-2.78,0.47 
           c-0.94,0.02-1.76-0.16-2.4-0.59c-0.2-0.13-0.38-0.27-0.53-0.42c-0.16,0.15-0.33,0.29-0.53,0.42c-0.65,0.43-1.46,0.61-2.4,0.59 
           c-0.83-0.02-1.76-0.19-2.78-0.47v0c-0.99-0.21-1.94-0.48-2.87-0.8c-0.92-0.31-1.83-0.68-2.71-1.09c-0.43-0.2-0.6-0.68-0.38-1.07 
           c0.13-0.23,0.37-0.38,0.63-0.43v0c0.47-0.07,0.85-0.13,1.2-0.18l0.03,0c1.14-0.16,2.01-0.28,3.08-0.71 
           c0.3-0.12,0.59-0.25,0.89-0.39c1.7-0.79,3.56-1.65,5.42-0.17c0.16,0.13,0.31,0.26,0.44,0.4c0.13-0.14,0.28-0.27,0.44-0.4 
           c1.86-1.48,3.72-0.62,5.42,0.17c0.3,0.14,0.59,0.27,0.89,0.39c1.06,0.43,1.94,0.55,3.08,0.71l0.03,0c0.35,0.05,0.73,0.1,1.2,0.18 
           l0,0c0.26,0.04,0.5,0.19,0.63,0.43c0.21,0.39,0.04,0.87-0.38,1.07C61.76,60.21,60.86,60.58,59.94,60.89L59.94,60.89L59.94,60.89z 
           M49.11,53.65c-0.37-0.31-0.42-0.87-0.11-1.24c0.31-0.37,0.87-0.42,1.24-0.11c0.44,0.37,0.86,0.57,1.27,0.57 
           c0.41,0.01,0.85-0.18,1.33-0.57c0.38-0.31,0.93-0.25,1.24,0.12c0.31,0.38,0.26,0.93-0.12,1.24c-0.81,0.67-1.64,0.99-2.47,0.97 
           C50.66,54.62,49.86,54.28,49.11,53.65L49.11,53.65L49.11,53.65z M46.34,65.3c-0.45-0.24-0.63-0.8-0.39-1.26 
           c0.24-0.45,0.8-0.63,1.26-0.39c1.43,0.76,2.84,1.15,4.22,1.15c1.38,0,2.77-0.37,4.16-1.14c0.45-0.25,1.01-0.08,1.26,0.37 
           c0.25,0.45,0.08,1.01-0.37,1.26c-1.66,0.92-3.35,1.37-5.05,1.37C49.73,66.66,48.03,66.2,46.34,65.3L46.34,65.3L46.34,65.3z 
           M27.59,52.51v-8.35c-0.38-1.61-1.09-2.09-1.88-2.24C23.56,41.59,23.76,52.01,27.59,52.51L27.59,52.51z"
				/>
			</g>
		</svg>
	</span>
);

export const FazendaSVG = () => (
	<span role="img" className="anticon">
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 122.88 85.5"
			style={{
				width: "1em",
				height: "1em",
				verticalAlign: "middle",
				overflow: "hidden",
				fill: "#455560",
			}}
		>
			<path
				className="cls-1"
				d="M45.44,15.53A.87.87,0,1,1,47,14.65l1.12,2a.87.87,0,0,1-1.51.87l-1.12-1.94Zm49.34,70L84.14,50H86.9L103,85.49H94.78ZM103,50V35.94H91.44c-1.94.18-2.33-1.36-1.5-2.63l7.39-8.67-.21-.21h-4c-1.44.21-2-1.34-1.1-2.44l8-9.37H97.7c-1.45,0-1.81-1.3-.88-2.57l7.26-8.62c.5-.59,1-1.45,1.89-1.43s1.19.72,1.63,1.24l7.72,9A1.5,1.5,0,0,1,114,12.71H111.9L119.81,22a1.55,1.55,0,0,1-.63,2.65h-4.6l6.9,8.09.76.89a1.47,1.47,0,0,1-1,2.32H108.85V50h14v7.2H96.08l-3-7.2H103ZM16.68,45.21v3.56H15.22V47.64h.33V45.21ZM8.23,41a6.56,6.56,0,0,1-1.47.25,5.47,5.47,0,0,1-3.09-.72,5.26,5.26,0,0,1-2.11-2.37A8.6,8.6,0,0,1,1.46,32,7.14,7.14,0,0,1,.12,27.1a6.15,6.15,0,0,1,1.65-3.42,7.88,7.88,0,0,1,3.48-2.09,11.3,11.3,0,0,1,7.85.73c.3-.24.6-.45.89-.65a7.44,7.44,0,0,1,5.27-1.35,8.44,8.44,0,0,1,5.12,3.27,15.4,15.4,0,0,1,1,1.31,7.6,7.6,0,0,1,4.69,1.28,4.5,4.5,0,0,1,1.61,2.07,4,4,0,0,1,0,2.63,7.29,7.29,0,0,1-3,3.6,9.3,9.3,0,0,1-1.1,3.78,4.79,4.79,0,0,1-2.09,2,3.81,3.81,0,0,1-2.83.13,5.17,5.17,0,0,1-.89-.38l-.59,1.39c-1.47,3.41-2,4.63-2.17,8.58H32.32l-3,7.2H0V50H11.74c-.05-3.76-.38-4.25-2.16-6.92-.38-.58-.82-1.25-1.35-2.1Zm1.07-.4,1.22,1.86c2,2.94,2.3,3.45,2.35,7.55h5c.18-4.19.72-5.45,2.26-9l.67-1.56c-.13-.1-.26-.2-.38-.31a7.78,7.78,0,0,1-.74.69,5.17,5.17,0,0,1-3.5,1.35,5.52,5.52,0,0,1-3.43-1.53c-.28-.25-.56-.52-.84-.82A9.67,9.67,0,0,1,9.3,40.59Zm3.4.24,2.3,3.8-1,.57-2.3-3.79,1-.58ZM40,85.5,46.66,50H43.37L32.75,85.5Zm-10.75,0L39.88,50H37.12L21.05,85.5Zm34.46,0V50H67L70.37,85.5ZM74,85.5,70.33,50h3.34l7,35.52Zm10,0L77.36,50h3.28L91.27,85.5Zm-23.71,0V50H57L53.64,85.5ZM50,85.5,53.68,50H50.34l-7,35.52ZM0,74.68H21.39L16.48,85.5H0V74.68Zm104,0h18.91V85.5h-14L104,74.68ZM0,62.26H27l-3.33,7.35H0V62.26Zm98.37,0h24.51v7.35H101.69l-3.32-7.35ZM52.42,18.42a7.82,7.82,0,1,1-5.54,2.29,7.83,7.83,0,0,1,5.54-2.29Zm4.35,3.47a6.15,6.15,0,0,0-10.5,4.35,6.15,6.15,0,1,0,12.3,0,6.07,6.07,0,0,0-1.8-4.35Zm-5-8.42a.88.88,0,1,1,1.75,0v2.25a.88.88,0,1,1-1.75,0V13.47Zm6.48,1.36a.88.88,0,0,1,1.19-.32.87.87,0,0,1,.32,1.19L58.6,17.65a.88.88,0,0,1-1.52-.87l1.13-2Zm4.93,4.42a.87.87,0,0,1,1.19.32.88.88,0,0,1-.32,1.2l-2,1.12a.87.87,0,0,1-.87-1.51l2-1.13Zm2.06,6.3a.88.88,0,0,1,0,1.76H63a.88.88,0,0,1,0-1.76ZM63.83,32A.88.88,0,0,1,63,33.55l-2-1.13a.87.87,0,1,1,.88-1.51L63.83,32ZM59.41,37a.87.87,0,0,1-.32,1.19.86.86,0,0,1-1.19-.32l-1.13-1.94a.87.87,0,0,1,.32-1.19.85.85,0,0,1,1.19.32L59.41,37ZM53.12,39a.88.88,0,0,1-1.76,0V36.78a.88.88,0,0,1,1.76,0V39Zm-6.48-1.37a.87.87,0,0,1-1.19.33.88.88,0,0,1-.33-1.2l1.13-1.94a.87.87,0,0,1,1.51.87l-1.12,1.94Zm-4.93-4.42a.87.87,0,1,1-.87-1.51l1.94-1.12a.87.87,0,0,1,.87,1.51l-1.94,1.12Zm-2.06-6.29a.88.88,0,1,1,0-1.75H41.9a.88.88,0,0,1,0,1.75ZM41,20.46A.87.87,0,1,1,41.89,19l1.94,1.12A.88.88,0,0,1,43,21.59L41,20.46Z"
			/>
		</svg>
	</span>
);

export const DoencaSVG = () => (
	<span role="img" className="anticon">
		<svg
			xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 122.88 117.34"
			style={{
				width: "1em",
				height: "1em",
				verticalAlign: "middle",
				overflow: "hidden",
				fill: "#455560",
			}}
		>
			<g>
				<path
					className="st0"
					d="M54.36,38.66c4.7,0,8.51,3.81,8.51,8.51c0,4.7-3.81,8.51-8.51,8.51c-4.7,0-8.51-3.81-8.51-8.51 
                     C45.84,42.47,49.66,38.66,54.36,38.66L54.36,38.66z M48.17,7.08c-1.5-3.34-5.42-4.83-8.76-3.34c-3.34,1.5-4.83,5.42-3.34,8.76 
                     c0.99,2.2,3.03,3.6,5.26,3.87l3.93,7.75c-3.68,1.8-7.02,4.19-9.89,7.06c-0.22,0.22-0.43,0.43-0.64,0.65l-9.43-5.02 
                     c0.12-1.25-0.02-2.55-0.46-3.81c-1.63-4.7-6.77-7.18-11.47-5.55c-4.7,1.63-7.18,6.77-5.55,11.47c1.63,4.7,6.77,7.18,11.47,5.55 
                     c0.99-0.34,1.88-0.84,2.66-1.46l8.38,4.46c-2.7,4.25-4.56,9.1-5.32,14.3l-6.86,0.1c-1.15-1.7-3.08-2.85-5.29-2.91 
                     c-3.66-0.11-6.71,2.77-6.82,6.43c-0.11,3.66,2.77,6.71,6.43,6.82c2.52,0.07,4.75-1.26,5.93-3.3l6.26-0.09 
                     c0.13,2.94,0.61,5.78,1.39,8.5l-17,9.2c-1.06-0.42-2.24-0.56-3.44-0.38c-3.62,0.57-6.09,3.96-5.52,7.58 
                     c0.57,3.62,3.96,6.09,7.58,5.52c3.41-0.54,5.81-3.59,5.59-6.97l15.42-8.34c1.75,3.41,4.03,6.51,6.71,9.2 
                     c0.2,0.2,0.41,0.41,0.62,0.61l-7.65,10.82c-1.38-0.31-2.85-0.3-4.31,0.09c-4.81,1.29-7.66,6.23-6.37,11.03 
                     c1.29,4.81,6.23,7.66,11.03,6.37c4.81-1.29,7.66-6.23,6.37-11.03c-0.23-0.85-0.57-1.64-1.01-2.36l7.47-10.56 
                     c4.33,2.78,9.29,4.68,14.62,5.43l-1.27,10.25c-3.49,1.73-4.96,5.94-3.29,9.48c1.69,3.57,5.96,5.1,9.53,3.4 
                     c3.57-1.69,5.1-5.96,3.4-9.53c-0.59-1.25-1.49-2.24-2.57-2.94l1.28-10.34c6.02-0.3,11.66-2.06,16.58-4.92l2.88,4.08l4,5.66 
                     c-0.44,0.72-0.78,1.51-1.01,2.36c-1.29,4.81,1.56,9.75,6.37,11.03c4.81,1.29,9.75-1.56,11.03-6.37c1.29-4.81-1.56-9.75-6.37-11.03 
                     c-1.46-0.39-2.93-0.4-4.31-0.09l-3.98-5.62l-2.92-4.12c0.62-0.54,1.22-1.1,1.8-1.68c2.44-2.43,4.53-5.21,6.21-8.25l16.28,5.76 
                     c0.7,2.91,3.32,5.07,6.44,5.07c3.66,0,6.63-2.97,6.63-6.63c0-3.66-2.97-6.63-6.63-6.63c-1.59,0-3.05,0.56-4.19,1.49l-15.73-5.57 
                     c1.13-3.54,1.75-7.31,1.75-11.23c0-3.54-0.5-6.97-1.44-10.21l8.75-4.27c1.01,0.79,2.25,1.33,3.62,1.48 
                     c3.93,0.44,7.47-2.39,7.91-6.32c0.44-3.93-2.39-7.47-6.32-7.91c-3.89-0.43-7.39,2.33-7.89,6.19l-8.69,4.24 
                     c-1.48-2.88-3.34-5.54-5.5-7.92l12.13-12.7c0.93,0.35,1.94,0.54,2.99,0.56c4.98,0.08,9.07-3.89,9.15-8.87 
                     c0.08-4.97-3.89-9.07-8.87-9.15s-9.07,3.89-9.15,8.87c-0.02,1.33,0.25,2.6,0.75,3.74L83.3,27.7c-3.56-2.66-7.63-4.69-12.02-5.92 
                     l1.07-9.01c2.27-0.92,3.94-3.07,4.12-5.68c0.26-3.65-2.5-6.82-6.15-7.08c-3.65-0.26-6.82,2.5-7.08,6.15 
                     c-0.15,2.1,0.7,4.04,2.14,5.35l-1.07,9.02c-0.98-0.08-1.96-0.12-2.96-0.12c-3.26,0-6.42,0.43-9.43,1.22l-4.21-8.29 
                     C48.87,11.53,49.12,9.19,48.17,7.08L48.17,7.08z M82.05,36.45c-5.3-5.3-12.62-8.57-20.7-8.57c-8.08,0-15.4,3.28-20.7,8.57 
                     c-5.3,5.3-8.57,12.62-8.57,20.7c0,8.08,3.28,15.4,8.57,20.7c5.3,5.3,12.62,8.57,20.7,8.57c8.08,0,15.4-3.28,20.7-8.57 
                     c5.3-5.3,8.57-12.62,8.57-20.7C90.63,49.07,87.35,41.75,82.05,36.45L82.05,36.45z M76.33,48.21c2.7,0,4.88,2.19,4.88,4.88 
                     c0,2.7-2.19,4.88-4.88,4.88c-2.7,0-4.88-2.19-4.88-4.88C71.45,50.39,73.63,48.21,76.33,48.21L76.33,48.21z M61.24,61.96 
                     c4.7,0,8.51,3.81,8.51,8.51c0,4.7-3.81,8.51-8.51,8.51c-4.7,0-8.51-3.81-8.51-8.51C52.72,65.78,56.53,61.96,61.24,61.96 L61.24,61.96z"
				/>
			</g>
		</svg>
	</span>
);

export const DaninhaSVG = () => (
	<span role="img" className="anticon">
		<svg
			xlink="http://www.w3.org/1999/xlink"
			viewBox="0 0 122.88 120.06"
			style={{
				width: "1em",
				height: "1em",
				verticalAlign: "middle",
				overflow: "hidden",
				fill: "#455560",
			}}
		>
			<g>
				<path
					className="st0"
					d="M11.72,110.28l7.39-0.31c-3.31-6.56-3.04-10.1-2.57-16.07c0.12-1.6,0.26-3.39,0.34-5.32 
                       c0.2-4.98,0.13-10.05-0.19-15.12c-0.24-3.89-0.63-7.77-1.15-11.62c-3.4,5.98-5.18,12.82-5.79,20.29 
                       C9.04,90.81,9.92,100.31,11.72,110.28L11.72,110.28z M8.88,112.03c-5.17,1.47-8.1,4.16-8.88,8.02h122.88 
                       c-3.11-5.52-8.77-9.01-19.08-8.76h-0.2c1.57-8.66,2.35-16.93,1.73-24.5c-0.64-7.94-2.81-15.13-7.18-21.22 
                       c-0.23-0.34-0.6-0.59-1.04-0.66c-0.85-0.13-1.64,0.44-1.77,1.29c-1.3,8.18-1.46,16.5-1.62,24.66l-0.03,1.57 
                       c-0.04,2.14,0,3.91,0.04,5.47c0.11,4.21,0.17,6.86-1.83,11.34c-1.68-10.62-2.77-21.29-3.23-32.07c-0.49-11.53-0.27-23.22,0.7-35.15 
                       c0.07-0.85-0.57-1.6-1.43-1.67c-0.78-0.06-1.47,0.46-1.64,1.21c-2.05,7.31-3.74,14.85-5.01,22.63c-1.28,7.8-2.14,15.84-2.55,24.15 
                       c0,0.06,0,0.12,0,0.18l0.22,6.18c-3.19-10.69-5.91-21.49-7.07-32.21c-1.55-14.31-0.33-28.5,6.22-42.16 
                       c0.37-0.77,0.04-1.7-0.73-2.06c-0.66-0.31-1.42-0.12-1.87,0.42l0,0c-6.71,8.21-11.08,19.29-13.08,33.29 
                       c-1.98,13.85-1.65,30.58,1.03,50.22c0,0.03,0.01,0.06,0.02,0.1l0,0l1.8,9.02H53.89l2.19-10.97l0,0c0.01-0.03,0.01-0.06,0.02-0.1 
                       c3.19-23.46,3.59-43.45,1.23-59.99c-2.39-16.69-7.59-29.9-15.58-39.68l0,0c-0.44-0.54-1.21-0.73-1.87-0.42 
                       c-0.77,0.37-1.1,1.29-0.73,2.06c7.87,16.4,9.33,33.43,7.47,50.6c-1.47,13.6-5.03,27.3-9.15,40.84l0.35-9.75c0-0.06,0-0.12,0-0.18 
                       c-0.49-9.93-1.52-19.54-3.04-28.86c-1.52-9.3-3.54-18.31-5.99-27.05c-0.17-0.74-0.86-1.27-1.64-1.2c-0.85,0.07-1.49,0.81-1.43,1.67 
                       c1.17,14.27,1.44,28.27,0.84,42.08c-0.57,13.27-1.93,26.4-4.04,39.48c-3.61-6.66-3.36-9.92-2.91-15.71 
                       c0.12-1.55,0.25-3.27,0.34-5.43c0.21-5.11,0.13-10.28-0.19-15.44c-0.33-5.34-0.94-10.69-1.78-15.99c-0.13-0.85-0.93-1.42-1.77-1.29 
                       c-0.44,0.07-0.81,0.32-1.04,0.66c-5.19,7.23-7.77,15.78-8.53,25.23C5.89,91.19,6.9,101.37,8.88,112.03L8.88,112.03z M94.94,110.04 
                       l5.69,0.24c1.47-8.23,2.19-16.08,1.61-23.25c-0.48-5.9-1.84-11.34-4.41-16.13c-0.75,6.63-0.88,13.38-1.01,20.02l-0.03,1.57 
                       c-0.04,2.07,0,3.8,0.04,5.34C96.94,102.36,97.01,105.25,94.94,110.04L94.94,110.04z 
                       M68.25,110.18h12.89h0.02h7.75 c-1.74-10.88-2.86-21.82-3.34-32.89c-0.26-6.08-0.33-12.18-0.19-18.33c-0.37,1.9-0.71,3.81-1.02,5.73 
                       c-1.26,7.67-2.11,15.58-2.51,23.75l0.64,17.73c0.03,0.85-0.64,1.57-1.49,1.6c-0.71,0.02-1.33-0.43-1.53-1.08 
                       c-4.63-14.43-9.05-29.18-10.65-43.88c-1.02-9.44-0.88-18.84,1.13-28.11c-2.01,5.22-3.49,11.12-4.43,17.7 
                       c-1.94,13.55-1.61,29.96,1.01,49.27l0,0L68.25,110.18L68.25,110.18z M35.29,110.15h15.67l2.09-10.43l0,0 
                       c3.14-23.13,3.54-42.8,1.22-59.04c-1.35-9.43-3.61-17.7-6.79-24.8c3.23,12.26,3.6,24.73,2.24,37.26 
                       c-1.9,17.56-7.2,35.19-12.72,52.43c-0.21,0.65-0.82,1.1-1.53,1.08c-0.85-0.03-1.52-0.75-1.49-1.6l0.77-21.22 
                       c-0.48-9.78-1.5-19.26-3-28.45c-0.57-3.49-1.21-6.94-1.92-10.36c0.28,8.56,0.23,17.04-0.13,25.47 
                       c-0.57,13.35-1.94,26.54-4.04,39.66h9.63H35.29L35.29,110.15z"
				/>
			</g>
		</svg>
	</span>
);
export const ProjetoSVG = () => (
	<span className="anticon">
		<svg
			width="23"
			height="20"
			viewBox="0 0 23 20"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9.80554 2.10742C10.1852 2.10742 10.493 2.41523 10.493 2.79492V9.66966L12.1421 8.43248C12.3865 8.24911 12.7226 8.24906 12.9671 8.43236L14.618 9.67018V2.79492C14.618 2.41523 14.9258 2.10742 15.3055 2.10742C15.6852 2.10742 15.993 2.41523 15.993 2.79492V11.0449C15.993 11.3053 15.8459 11.5434 15.613 11.6598C15.3802 11.7763 15.1015 11.7512 14.8931 11.595L12.5548 9.8418L10.2181 11.5949C10.0098 11.7511 9.73107 11.7763 9.49813 11.6599C9.26519 11.5434 9.11804 11.3053 9.11804 11.0449V2.79492C9.11804 2.41523 9.42585 2.10742 9.80554 2.10742Z"
				fill="#0057B8"
			/>
			<path
				d="M4.4235 2.91288C4.93922 2.39715 5.6387 2.10742 6.36804 2.10742H18.0555C18.4352 2.10742 18.743 2.41523 18.743 2.79492V16.5449C18.743 16.9246 18.4352 17.2324 18.0555 17.2324H6.36804C6.00337 17.2324 5.65363 17.3773 5.39577 17.6351C5.13791 17.893 4.99304 18.2427 4.99304 18.6074C4.99304 18.9871 4.68524 19.2949 4.30554 19.2949C3.92585 19.2949 3.61804 18.9871 3.61804 18.6074V4.85742C3.61804 4.12808 3.90777 3.4286 4.4235 2.91288ZM4.99304 16.2258C5.40754 15.9866 5.88113 15.8574 6.36804 15.8574H17.368V3.48242H6.36804C6.00337 3.48242 5.65363 3.62729 5.39577 3.88515C5.13791 4.14301 4.99304 4.49275 4.99304 4.85742V16.2258Z"
				fill="#0057B8"
			/>
			<path
				d="M4.30554 17.9199C4.68524 17.9199 4.99304 18.2277 4.99304 18.6074H16.6805C17.0602 18.6074 17.368 18.9152 17.368 19.2949C17.368 19.6746 17.0602 19.9824 16.6805 19.9824H4.30554C3.92585 19.9824 3.61804 19.6746 3.61804 19.2949V18.6074C3.61804 18.2277 3.92585 17.9199 4.30554 17.9199Z"
				fill="#0057B8"
			/>
		</svg>
	</span>
);
